import { Utils } from '@/libs/Utils'
import React from 'react'
import { Col, Form } from 'react-bootstrap'

const PhoneNumber: React.FC<{ locale: string }> = ({ locale }) => {
    const t = new Utils(locale).Translation
    return (
        <Form.Group as={Col} md={12} xs={12} className="mb-3">
            <Form.Label>{t("form.phone")} <span className="text-danger">*</span></Form.Label>
            <Form.Control required pattern="^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$" type="tel" name="phone" />
            <Form.Control.Feedback type="invalid">[{t("form.phone")}] {t("required.message")}</Form.Control.Feedback>
        </Form.Group>
    )
}

export default PhoneNumber